module.exports = __webpack_public_path__ + "static/media/punk_male.1bac2293.png";